import { SVGProps } from 'react';

export const Add = ({ width = 16, height = 16, fill = '#0039A7' }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill={fill} />
      <path d="M8 4V12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 8L4 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};
